import { render } from "./user-dashboard-header.vue?vue&type=template&id=d2a59c0e"
import script from "./user-dashboard-header.vue?vue&type=script&lang=js"
export * from "./user-dashboard-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__